import { useT } from '../../../../app/lib/i18n'
import type { QuickFilterConfig } from '../FilterBar.types'
import { Modal } from '../../Modal'
import { QuickFilterControl } from './QuickFilterControl'
import * as styles from '../FilterBar.style.css'

export interface QuickFiltersModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  /** Visible quick filters to show (same as filter bar) */
  quickFilters: QuickFilterConfig[]
  getFilterValue: (id: string) => unknown
  onFilterChange: (id: string, value: unknown) => void
}

export function QuickFiltersModal({
  open,
  onOpenChange,
  quickFilters,
  getFilterValue,
  onFilterChange,
}: QuickFiltersModalProps) {
  const t = useT()
  return (
    <Modal
      open={open}
      setOpen={onOpenChange}
      closeOnClickOff
      darkenBackground
    >
      <div className={styles.quickFiltersModalContent}>
        <h2 className={styles.quickFiltersModalTitle}>{t("shared.filter.filters")}</h2>
        <div className={styles.quickFiltersModalList}>
          {quickFilters.map((config) => (
            <div key={config.id} className={styles.quickFiltersModalItem}>
              <QuickFilterControl
                config={config}
                value={getFilterValue(config.id)}
                onChange={(v) => onFilterChange(config.id, v)}
                variant="modal"
              />
            </div>
          ))}
        </div>
      </div>
    </Modal>
  )
}
